export const defaultPermissions = [
  {
    roleType: "Technician",
    predefinedPermissions: [
      { entity: "rack_management", actions: ["view"] },
      {
        entity: "warehouse",
        actions: ["view", "view_product_bin", "view_warehouse_product"],
      },
      { entity: "product_request", actions: ["view"] },
      { entity: "job", actions: ["view"] },
      { entity: "location", actions: ["view"] },
      { entity: "vendor", actions: ["view"] },
      { entity: "stakeholder", actions: ["view"] },
      { entity: "phase", actions: ["view"] },
      { entity: "system", actions: ["view"] },
    ],
  },
  {
    roleType: "Purchasing",
    predefinedPermissions: [
      { entity: "product_request", actions: ["view", "update"] },
      {
        entity: "purchase_order",
        actions: ["view", "create", "update", "delete", "status"],
      },
    ],
  },
  {
    roleType: "Warehouse",
    predefinedPermissions: [
      {
        entity: "rack_management",
        actions: ["view", "create", "update", "status", "update_bin_status"],
      },
      {
        entity: "user",
        actions: ["view", "create", "update", "delete", "status"],
      },
      {
        entity: "manufacturer",
        actions: ["view", "create", "update", "delete", "status"],
      },
      {
        entity: "warehouse",
        actions: [
          "view",
          "update",
          "view_product_bin",
          "fill_product_into_bin",
          "view_warehouse_product",
          "import_product",
        ],
      },
      {
        entity: "product_request",
        actions: ["view", "create", "update", "delete", "add_custom_product"],
      },
      {
        entity: "job",
        actions: [
          "view",
          "create",
          "update",
          "delete",
          "status",
          "download_reports",
          "view_job_product_report",
          "update_job_item_status",
        ],
      },
      {
        entity: "location",
        actions: ["view", "create", "update", "delete", "status"],
      },
      {
        entity: "vendor",
        actions: ["view", "create", "update", "delete", "status"],
      },
      {
        entity: "stakeholder",
        actions: [
          "view",
          "create",
          "update",
          "delete",
          "status",
          "delete_contact",
        ],
      },
      {
        entity: "phase",
        actions: ["view", "create", "update", "delete", "status"],
      },
      {
        entity: "system",
        actions: ["view", "create", "update", "delete", "status"],
      },
    ],
  },
  {
    roleType: "Supplier",
    predefinedPermissions: [
      { entity: "product_request", actions: ["view", "update"] },
      {
        entity: "purchase_order",
        actions: ["view", "create", "update", "delete", "status"],
      },
    ],
  },
  {
    roleType: "Admin",
    predefinedPermissions: [
      {
        entity: "general_product_category",
        actions: ["view", "create", "update", "delete", "status"],
      },
      {
        entity: "product_request",
        actions: [
          "view",
          "create",
          "update",
          "delete",
          "status",
          "add_custom_product",
        ],
      },
      {
        entity: "manufacturer",
        actions: ["view", "create", "update", "delete", "status"],
      },
      {
        entity: "rack_management",
        actions: [
          "view",
          "create",
          "update",
          "delete",
          "status",
          "update_bin_status",
        ],
      },
      {
        entity: "user",
        actions: ["view", "create", "update", "delete", "status"],
      },
      {
        entity: "warehouse",
        actions: [
          "view",
          "create",
          "update",
          "delete",
          "status",
          "view_product_bin",
          "fill_product_into_bin",
          "view_warehouse_product",
          "import_product",
        ],
      },
      {
        entity: "general_product",
        actions: ["view", "create", "update", "delete", "status"],
      },
      {
        entity: "purchase_order",
        actions: ["view", "create", "update", "delete", "status"],
      },
      {
        entity: "job",
        actions: [
          "view",
          "create",
          "update",
          "delete",
          "status",
          "download_reports",
          "view_job_product_report",
          "update_job_item_status",
          "create_bom",
          "edit_bom",
          "view_bom",
          "delete_bom",
          "print_bom",
          "create_bom_pr",
        ],
      },
      {
        entity: "stakeholder",
        actions: [
          "view",
          "create",
          "update",
          "delete",
          "status",
          "delete_contact",
        ],
      },
      {
        entity: "location",
        actions: ["view", "create", "update", "delete", "status"],
      },
      {
        entity: "phase",
        actions: ["view", "create", "update", "delete", "status"],
      },
      {
        entity: "vendor",
        actions: ["view", "create", "update", "delete", "status"],
      },
      {
        entity: "system",
        actions: ["view", "create", "update", "delete", "status"],
      },
    ],
  },
];
